import React from 'react'
import ReactDOM from 'react-dom/client'
import * as Sentry from '@sentry/react'
import app from './config/firebase'
import App from './App.tsx'
import './assets/scss/app.scss'
import { setFirebaseApp } from '@common/config/firebase.config'

const isProductionMode = import.meta.env.MODE === 'production'
const sentryDsn = isProductionMode
  ? import.meta.env.VITE_SENTRY_DSN_PROD
  : import.meta.env.VITE_SENTRY_DSN_DEV

if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment: import.meta.env.MODE,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: isProductionMode ? 0.1 : 0.0,
    replaysSessionSampleRate: 0.0,
    replaysOnErrorSampleRate: 0.0,
    sendDefaultPii: false,
    beforeBreadcrumb(breadcrumb) {
      if (breadcrumb.category === 'fetch' && breadcrumb.data?.url?.includes('firestore.googleapis.com')) {
        return null
      }
      return breadcrumb
    },
  })
}

// Firebaseアプリを共通モジュールに設定
setFirebaseApp(app)

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)

